import "bootstrap";
import 'bootstrap/dist/css/bootstrap.css' // Import precompiled Bootstrap css
import '@fortawesome/fontawesome-free/css/all.css'
import './css/site.css';

import { createRouter, createWebHashHistory } from 'vue-router';
import Login from './components/Login.vue';
import Modelings from './components/modelings/Modelings.vue';
import Settings from './components/settings/Settings.vue';

import ModelingDetail from './components/modelings/ModelingDetail.vue';
import ModelingImport from './components/modelings/ModelingImport.vue';
import ModelingResultDetail from './components/modelings/ModelingResultDetail.vue';

import WeightedAverageCharts from './components/results/WeightedAverageCharts.vue';
import ActivityCharts from './components/results/ActivityCharts.vue';
import DistributionCharts from './components/results/DistributionCharts.vue';
import ActivityPlan from './components/results/ActivityPlan.vue';
import SumarizedCostCharts from './components/results/SumarizedCostCharts.vue';

import DatasetDetail from './components/datasets/DatasetDetail.vue';
import DatasetCreate from './components/datasets/DatasetCreate.vue';

import ForecastDetail from './components/forecasts/ForecastDetail.vue';
import ForecastCreate from './components/forecasts/ForecastCreate.vue';

import SelectionDetail from './components/selections/SelectionDetail.vue';
import SelectionCreate from './components/selections/SelectionCreate.vue';
import SelectionInfo from './components/selections/SelectionInfo.vue';

import PerformanceDetail from './components/performances/PerformanceDetail.vue';
import PerformanceCreate from './components/performances/PerformanceCreate.vue';

import SettingsModelingDetail from './components/settings/modelings/ModelingDetail.vue';

import AssetTypeDetail from './components/assetTypes/AssetTypeDetail.vue';
import AssetTypeCreate from './components/assetTypes/AssetTypeCreate.vue';
import AssetTypeInfoSet from './components/assetTypes/AssetTypeInfoSet.vue';

import ActivityDetail from './components/activities/ActivityDetail.vue';
import ActivityCreate from './components/activities/ActivityCreate.vue';

import ParameterDetail from './components/parameters/ParameterDetail.vue';
import ParameterInfoDetail from './components/parameters/ParameterInfoDetail.vue';
import ParameterCreate from './components/parameters/ParameterCreate.vue'

import KPIDetail from './components/kpi/KPIDetail.vue';
import KPICreate from './components/kpi/KPICreate.vue'

import LifeCycleDetail from './components/lifeCycles/LifeCycleDetail.vue';
import LifeCycleCreate from './components/lifeCycles/LifeCycleCreate.vue';

import BenefitDetail from './components/benefits/BenefitDetail.vue';
import BenefitCreate from './components/benefits/BenefitCreate.vue';

import GroupAdd from './components/settings/groups/GroupAdd.vue';
import GroupDetail from './components/settings/groups/GroupDetail.vue';
import GroupList from './components/settings/groups/GroupList.vue';

import SettingsModelingAdd from './components/settings/modelings/ModelingAdd.vue';
import SettingsModelingList from './components/settings/modelings/ModelingList.vue';

import SelectionGroupDetail from "./components/selections/groups/SelectionGroupDetail.vue";
import SelectionGroupCreate from "./components/selections/groups/SelectionGroupCreate.vue";

import SelectionPackageDetail from "./components/selections/packages/SelectionPackageDetail.vue";
import SelectionPackageCreate from "./components/selections/packages/SelectionPackageCreate.vue";

import SelectionLimitDetail from "./components/selections/limits/SelectionLimitDetail.vue";
import SelectionLimitCreate from "./components/selections/limits/SelectionLimitCreate.vue";

import UserAdd from './components/settings/users/UserAdd.vue';
import UserDetail from './components/settings/users/UserDetail.vue';
import UserList from './components/settings/users/UserList.vue';

import ParameterEvaluationCreate from "./components/parameters/ParameterEvaluationCreate.vue";
import ParameterEvaluationDetail from "./components/parameters/ParameterEvaluationDetail.vue";

import CurveCreate from "./components/curves/CurveCreate.vue";
import CurveDetail from "./components/curves/CurveDetail.vue";

import EvaluationCreate from "./components/evaluations/EvaluationCreate.vue";
import EvaluationDetail from "./components/evaluations/EvaluationDetail.vue";
import AuthorizationApi from "./api/server/authorization";

const routes = [
    {
        path: '/',
        name: 'Login',
        component: Login
    },
    {
        path: '/modelings',
        name: 'Modelings',
        component: Modelings
    },
    {
        path: '/modeling/:id',
        // component: Modeling,
        props: true,
        children: [
            {
                path: '/modeling/:id/modelingresult/:modelingResultId',
                name: 'modelingresult',
                component: ModelingResultDetail,
                props: true
            },
            {
                path: 'modelingresult/:modelingResultId',
                props: true,
                children: [
                    {
                        path: 'weightedaverage',
                        component: WeightedAverageCharts,
                        props: true
                    },
                    {
                        path: 'activity',
                        component: ActivityCharts,
                        props: true
                    },
                    {
                        path: 'distribution',
                        component: DistributionCharts,
                        props: true
                    },
                    {
                        path: 'activityplan',
                        component: ActivityPlan,
                        props: true
                    },
                    {
                        path: 'sumarizedcost',
                        component: SumarizedCostCharts,
                        props: true
                    }
                ]
            },
            {
                path: 'datasetcreate',
                component: DatasetCreate,
                props: true
            },
            {
                path: 'dataset/:datasetId',
                component: DatasetDetail,
                props: true
            },
            {
                path: 'forecastcreate',
                component: ForecastCreate,
                props: true
            },
            {
                path: 'forecast/:forecastId',
                component: ForecastDetail,
                props: true
            },
            {
                path: 'selection/:selectionId',
                component: SelectionDetail,
                props: true
            },
            {
                path: 'selectioncreate/:forecastId',
                component: SelectionCreate,
                props: true
            },
            {
                path: 'selectioninfo/:selectionId',
                component: SelectionInfo,
                props: true
            },
            {
                path: 'selection/:selectionId/group/:groupId',
                component: SelectionGroupDetail,
                props: true
            },
            {
                path: 'selection/:selectionId/groupcreate',
                component: SelectionGroupCreate,
                props: true
            },
            {
                path: 'selection/:selectionId/package/:packageId',
                component: SelectionPackageDetail,
                props: true
            },
            {
                path: 'selection/:selectionId/packagecreate',
                component: SelectionPackageCreate,
                props: true
            },
            {
                path: 'selection/:selectionId/limit/:limitId',
                component: SelectionLimitDetail,
                props: true
            },
            {
                path: 'selection/:selectionId/limitcreate',
                component: SelectionLimitCreate,
                props: true
            },
            {
                path: 'assettypecreate/:datasetId',
                component: AssetTypeCreate,
                props: true
            },
            {
                path: 'assettype/:assetTypeId',
                component: AssetTypeDetail,
                props: true
            },
            {
                path: 'assettypeinfoset/:assetTypeId',
                component: AssetTypeInfoSet,
                props: true
            },
            {
                path: 'assettype/:assetTypeId',
                props: true,
                children: [
                    {
                        path: 'activity/:activityId',
                        component: ActivityDetail,
                        props: true
                    },
                    {
                        path: 'activitycreate',
                        component: ActivityCreate,
                        props: true
                    },
                    {
                        path: 'parameter/:parameterId',
                        component: ParameterDetail,
                        props: true
                    },
                    {
                        path: 'parameter/:parameterId/parameterinfo',
                        component: ParameterInfoDetail,
                        props: true
                    },
                    {
                        path: 'parametercreate',
                        component: ParameterCreate,
                        props: true
                    },
                    {
                        path: 'parameter/:parameterId',
                        props: true,
                        children: [
                            {
                                path: 'evaluation/:evaluationId',
                                component: ParameterEvaluationDetail,
                                props: true
                            },
                            {
                                path: 'evaluationcreate',
                                component: ParameterEvaluationCreate,
                                props: true
                            },
                        ]
                    },
                    
                    {
                        path: 'curve/:curveId',
                        component: CurveDetail,
                        props: true
                    },
                    {
                        path: 'curvecreate/:parameterId',
                        component: CurveCreate,
                        props: true
                    },
                    {
                        path: 'kpi/:keyPerformanceIndicatorId',
                        component: KPIDetail,
                        props: true
                    },
                    {
                        path: 'kpicreate',
                        component: KPICreate,
                        props: true
                    },
                    {
                        path: 'evaluation/:evaluationId',
                        component: EvaluationDetail,
                        props: true
                    },
                    {
                        path: 'evaluationcreate/:keyPerformanceIndicatorId',
                        component: EvaluationCreate,
                        props: true
                    },
                    {
                        path: 'lifecycle/:lifeCycleId',
                        component: LifeCycleDetail,
                        props: true
                    },
                    {
                        path: 'lifecyclecreate',
                        component: LifeCycleCreate,
                        props: true
                    },
                    {
                        path: 'benefit/:benefitId',
                        component: BenefitDetail,
                        props: true
                    },
                    {
                        path: 'benefitcreate',
                        component: BenefitCreate,
                        props: true
                    },
                    {
                        path: 'performancecreate',
                        component: PerformanceCreate,
                        props: true
                    },
                    {
                        path: 'performance/:performanceId',
                        component: PerformanceDetail,
                        props: true
                    },
                ]
            }
        ]
    },
    {
        path: '/groupadd',
        name: 'groupadd',
        component: GroupAdd
    },
    {
        path: '/groupdetail/:id',
        name: 'groupdetail',
        component: GroupDetail,
        props: true
    },
    //ADMIN - SETTINGS
    {
        path: '/modelingadd',
        name: 'modelingadd',
        component: SettingsModelingAdd
    },
    {
        path: '/modeling/:id',
        name: 'modeling',
        component: ModelingDetail,
        props: true
    },
    {
        path: '/modeling/:id/import',
        component: ModelingImport,
        props: true
    },
    {
        path: '/settingsmodelingdetail/:id',
        name: 'settingsmodelingdetail',
        component: SettingsModelingDetail,
        props: true
    },
    // {
    //     path: '/admininspectiondetail/:id',
    //     name: 'admininspectiondetail',
    //     component: AdminInspectionDetail,
    //     props: true
    // },
    // {
    //     path: '/modelingview/:id',
    //     name: 'modelingview',
    //     component: AdminModelingView,
    //     props: true
    // },

    {
        path: '/userdetail/:id',
        name: 'userdetail',
        component: UserDetail,
        props: true
    },
    {
        path: '/useradd',
        name: 'useradd',
        component: UserAdd
    },
    {
        path: '/settings',
        name: "settings",
        component: Settings,
        props: true,
        children: [
            {
                path: 'users',
                name: "users",
                component: UserList
            },
            {
                path: 'groups',
                name: "groups",
                component: GroupList
            },
            {
                path: 'modelings',
                name: "modelings",
                component: SettingsModelingList
            }
        ]
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.beforeEach(async (to, from, next) => {
    var auth = await AuthorizationApi.auth();
    console.log(auth, to)
    if (to.name !== 'Login' && !auth.isAuthenticated) {
        next({
            name: 'Login',
            query: { returnUrl: to.fullPath }
        });
    } else {
        next();
    }
});

if (!window.indexedDB) {
    console.log("Your browser doesn't support a stable version of IndexedDB. Such and such feature will not be available.");
}

export default router;